var utils = require("@/common/utils");
var TimerLabel = require("./TimerLabel");
var profile = require("@/app/tools/profile");
var tools = require("@/app/tools/tools");
var wrapperDom;
var timerBarDom;
var statusTextDom;
var acceptButtonDom;
var endButtonDom;
var collapseToggleButton;

var timerLabel;
var showClosingTimerHandler;

var acceptCallback;
var endCallback;

var nopFunction = function(){};

module.exports = {
	init: init,
	startTimer: startTimer,
	show: show,
	hide: hide,
	toggleCollapse: toggleCollapse,
	showClosing: showClosing,
	reset: reset,
	hideAcceptButton: hideAcceptButton,
	setStatusText: setStatusText,
	accept: accept,
	end: end,

};

function init(option){
	var opt = option || {};

	if(wrapperDom) throw new Error("statusBar has been already initialized.");

	wrapperDom = opt.wrapperDom;
	acceptCallback = opt.acceptCallback || nopFunction;
	endCallback = opt.endCallback || nopFunction;

	timerBarDom = wrapperDom.querySelector(".time-escape");
	statusTextDom = wrapperDom.querySelector(".status-text");
	acceptButtonDom = wrapperDom.querySelector(".accept-button");
	endButtonDom = wrapperDom.querySelector(".end-button");
	collapseToggleButton = wrapperDom.querySelector(".collapse-toggle-button");

	timerLabel = new TimerLabel(timerBarDom);

	utils.on(acceptButtonDom, "click", acceptCallback);
	utils.on(endButtonDom, "click", endCallback);
	utils.on(collapseToggleButton, "click", function(){
		toggleCollapse();
	});
}

function setStatusText(text){
	statusTextDom.innerText = text;
}

function toggleCollapse(state){
	utils.toggleClass(wrapperDom, "collapsed", state);
}

function startTimer(){
	timerLabel.start();
}

function show(){
	if(!window.creatWhiteboard){
		if(profile.grayList.whiteBoard){
			// 加载白板的CSS  不能这样，因为主界面还是要用 白板的CSS ！！！！！！！！！！
			// var cssLink=$('<link rel="stylesheet" type="text/css" href="./static/white_css/white_board.css">');
			// $('head').append(cssLink);
			// 加载白板JS
			var STATIC_PATH = "zh-CN" === "zh-CN" ? "static" : "../static";
			var whiteBoardPath = STATIC_PATH + "/js/lib/white_board.js";
			tools.loadScript(whiteBoardPath).then(function(){
				window.lodash = _.noConflict();
			})
		} 
	}
	utils.removeClass(wrapperDom, "hide");
	startTimer();
}

function hide(){
	utils.addClass(wrapperDom, "hide");
}

function showClosing(){
	toggleCollapse(true);
	utils.addClass(wrapperDom, "terminated");
	setStatusText("视频已结束");

	timerLabel.stop();

	clearTimeout(showClosingTimerHandler);
	showClosingTimerHandler = setTimeout(function(){
		hide();
		reset();
	}, 3000);
}

function reset(){
	toggleCollapse(false);
	utils.removeClass(wrapperDom, "terminated");
	// utils.removeClass(acceptButtonDom, "hide");
	showClosingTimerHandler = clearTimeout(showClosingTimerHandler);
	timerLabel.stop();
	setStatusText("等待中");
	// 移除取消通话按钮
	var editor = document.querySelector(".toolbar");
	var ele = document.querySelector(".visitor-invite-video-confirms");
	if(ele){
		$(ele).addClass("hide");
	}
}

function hideAcceptButton(){
	utils.addClass(acceptButtonDom, "hide");
}

function accept(){
	acceptButtonDom.click()
}

function end(){
	endButtonDom.click()
}

